import styled from 'styled-components';

import { Text, Card, Tag, Button, Skeleton } from '@gympass/yoga';
import { Info } from '@gympass/yoga-icons';

export const PatientRecords = styled(Card)`
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const SubTitle = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  color: ${({ theme }) => theme.yoga.colors.deep};
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const SubTitleHighlight = styled.b`
  color: inherit;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const RecordTopic = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.zero};
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: ${({ theme }) =>
      `${theme.yoga.borders.small}px solid ${theme.yoga.colors.separatorBackground}`};
  }

  &:last-child {
    padding-bottom: ${({ theme }) => theme.yoga.spacing.zero};
  }
`;

export const RecordTopicContainer = styled.div``;

export const RecordTopicHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const RecordTopicTitle = styled(Text.SectionTitle)`
  color: ${({ theme }) => theme.yoga.colors.text.primary};
`;

export const LastUpdateInfo = styled(Text.Tiny)`
  color: ${({ theme }) => `${theme.yoga.colors.text.disabled}`};
`;

export const ShareableTag = styled(Tag.Informative)`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => `${theme.yoga.colors.primaryExtraLight}`};
`;

export const RecordTopicContent = styled(Text.Small)`
  margin-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const MoreInfoIconContainer = styled.div`
  display: flex;
`;

export const MoreInfoIcon = styled(Info).attrs({
  width: '16',
  height: '16',
})`
  fill: ${({ theme }) => theme.yoga.colors.elements.selectionAndIcons};
`;

export const ViewMoreButton = styled(Button.Icon)`
  height: auto;
  display: flex;
  justify-content: end;
  margin-left: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const LoadingInfo = styled(Skeleton)`
  width: 100%;
`;
